import LZString from 'lz-string'

export const compress = (o: any) => {
  let compressed = LZString.compress(JSON.stringify(o))
  return compressed
}
export const decompress = (d: any) => {
  let hexmapDecompressed = LZString.decompress(d)
  return JSON.parse(hexmapDecompressed || '')
}
